// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoiceSchema } from './v1/invoiceSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listInvoicesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const listInvoicesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoices retrieved
 */
export const listInvoices200Schema = z.array(z.lazy(() => v1InvoiceSchema));

/**
 * @description Unauthorized
 */
export const listInvoices401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listInvoicesQueryResponseSchema = z.lazy(() => listInvoices200Schema);
